export function getWeightClassName(vehicle) {
    if (!vehicle || typeof vehicle !== 'object') {
        return 'measurement-row-field-b'
    }

    const { totalLoad, limitTotalLoad } = vehicle

    if (
        typeof totalLoad === 'number' &&
        typeof limitTotalLoad === 'number' &&
        totalLoad >= limitTotalLoad
    ) {
        return 'measurement-row-field-b-red'
    }

    return 'measurement-row-field-b'
}

export function getSpeedClassName(vehicle) {
    if (!vehicle || typeof vehicle !== 'object') {
        return 'measurement-row-field-b'
    }

    return vehicle.overspeed === true
        ? 'measurement-row-field-b-red'
        : 'measurement-row-field-b'
}

export function getCategoryClass(ctg8p1) {
    if (!ctg8p1 || typeof ctg8p1 !== 'string') {
        return ''
    }

    return ` icon-${ctg8p1}`
}
